module.exports = __webpack_public_path__ + "img/icon_head.2e8d3eab.svg";